// Slider config moved to: assets/js/components/ui-components/slick-slider.js (preset "merchant-reviews")
// Template updated: templates/public/static/builder-merchant/main-contemt.html.twig (data-lazy-init="slick-slider")

import $ from "jquery";

$(".widget_btn").click(function(){
    $("#sb_enterprise_widget").trigger("click");
});